'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HUMAN = exports.HUMAN = 'HUMAN';
var BOT = exports.BOT = 'BOT';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/constants/agentTypes.js
// module id = 592
// module chunks = 2 3